import React from 'react';

import { OrganizationAppShell } from '~/components/layouts';
import { Patient } from '~/components/pages/Patient';
import { FirebaseProvider } from '~/components/partials';

const PatientPage = () => {
  return (
    <FirebaseProvider>
      <OrganizationAppShell>
        <Patient />
      </OrganizationAppShell>
    </FirebaseProvider>
  );
};

export default PatientPage;
